import styled from 'styled-components';
import classNames from 'classnames';
import materialIcons from '../constants/material-icons-constants';
import Icon, { IconProps } from '../icon';

interface IconAnimatedChevronProps extends Omit<IconProps, 'name'> {
  icon?: keyof typeof materialIcons;
  isOn?: boolean;
  rotate?: number;
}

export const IconAnimatedChevron = styled(
  ({ className, isOn, icon = 'CHEVRON_UP', size = 'lg', ...rest }: IconAnimatedChevronProps) => (
    <Icon
      className={classNames('box-animated-chevron', className, { on: isOn }, { off: !isOn })}
      name={icon}
      size={size}
      {...rest}
    />
  ),
)<IconAnimatedChevronProps>`
  transition: all 250ms ease-in-out;

  &.on {
    transform: rotate(0deg);
  }

  &.off {
    transform: rotate(${props => props.rotate || 180}deg);
  }
`;

export default IconAnimatedChevron;
